import React, {useState, useEffect} from 'react';

function LazyLoadImage (props) {

    var p = { ...props };
    if (p.load) {
        p.src = p.path;
    }
    
    const [src, setSrc] = useState(p.load ? p.path : p.src);

    useEffect(() => {
        setSrc(p.load ? p.path : p.src);
    }, [props]);


    let imgContent = <img src={src} alt='ZoneHistory' className={props.className} pos={props.pos} width={props.width} onClick={props.onClick} />;
    return <div id={props.id} className={props.containerClassName}>{imgContent}{props.content}</div>
}

export default LazyLoadImage;
